import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';

export const useSwipeNavigation = () => {
  const navigate = useNavigate();

  return useSwipeable({
    onSwipedRight: () => navigate(-1),
    onSwipedLeft: () => navigate(1),
    preventDefaultTouchmoveEvent: true,
    trackMouse: false,
    delta: 50,
    swipeDuration: 500
  });
};